import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import DialogCrud from '../shared/DialogCrud.jsx';
import DataTableLinks from './atom/DataTableLinks.jsx';
import FormCadastrarLinks from './atom/FormCadastrarLinks.jsx';
import linksTvService from '../../../services/tvs/linksTvService.js';
import { Growl } from 'primereact/growl';
import { mostrarMensagemErro, mostrarMensagemSucesso } from './helpers/toast.js';
import  './style.css';

export default function ManutencaoLinks() {
    const [openModalCadastro,setOpenModalCadastro] = useState(false);
    const [loadTable,setLoadTable] = useState(false);
    const [loadingSubmit,setLoadingSubmit] = useState(false);
    const mensagemToast = useRef(null);
    const cadastrarLinks = async (dados,{ resetForm }) => {
        try {
            setLoadingSubmit(true);

            const { nome,url } = dados;

            await linksTvService.cadastrarLink({ nome,
                url });
            resetForm({ nome: '',
                url: '' });
            setLoadingSubmit(false);
            setOpenModalCadastro(false);
            setLoadTable(!loadTable);
            mostrarMensagemSucesso(mensagemToast, 'Cadastro realizado com sucesso.');
        } catch (error) {
            setLoadingSubmit(false);
            mostrarMensagemErro(mensagemToast, 'Falha ao cadastrar, tente novamente mais tarde.');
        }
    };

    return (
        <Card className='tratar-scroll-card p-card' title="Links">
            <Growl ref={mensagemToast} />
            <Button style={{ marginBottom: '0.5rem',
                padding: '4px 10px 4px 10px'
            }} label='Cadastrar' onClick={setOpenModalCadastro.bind(this,true)}/>
            <DialogCrud loading={loadingSubmit} title={'Cadastrar link'} openModal={openModalCadastro} setOpenModal={setOpenModalCadastro}>
                <FormCadastrarLinks handleSubmitFormik={cadastrarLinks}/>
            </DialogCrud>
            <DataTableLinks mensagemToast={mensagemToast} setLoadTable={setLoadTable} loadTable={loadTable}/>
        </Card>
    );
}
